import {
  SET_UNITS,
  TOGGLE_PROJECT_DIALOG,
  SAVE_PROJECT_DATA,
  LOAD_PROJECTS,
  SELECT_PROJECT,
  DELETE_PROJECT,
  TOGGLE_SCENARIO_DIALOG,
  SAVE_SCENARIO_DATA,
  LOAD_SCENARIOS,
  SELECT_SCENARIO,
  DELETE_SCENARIO,
  SAVE_OBSTACLE_DATA,
  UPDATE_OBSTACLE_DATA,
  UPDATE_OBSTACLE_BY_GUID,
  SELECT_OBSTACLE,
  DELETE_OBSTACLE,
  DELETE_OBSTACLE_BY_GUID,
  SAVE_ATTACK_DATA,
  UPDATE_ATTACK_DATA,
  UPDATE_ATTACK_BY_GUID,
  SELECT_ATTACK,
  DELETE_ATTACK,
  DELETE_ATTACK_BY_GUID,
  RESET,
  SET_MAP_CHOICE,
  UPDATE_PROJECT_BUILDINGS,
  ACCEPT_T_AND_C,
  RESET_T_AND_C,
} from '../actionTypes'
import { UNITS } from '../../../lib/const'

const initialState = {
  projects: [],
  scenarios: [],
  selectedProjectId: null,
  selectedScenarioId: null,
  projectDialogOpen: false,
  projectScenarioOpen: false,
  obstacles: [],
  attacks: [],
  selectedObstacle: {},
  selectedAttack: {},
  mapChoice: 'light-v9',
  remoteStorage: {
    projects: false,
    scenarios: false,
    attacks: false,
    obstacles: false,
  },
  acceptedTandC: true,
  units: Object.keys(UNITS)[0],
}

const rootReducer = (state = initialState, { type, payload }) => {
  let selectedObstacle, selectedAttack
  switch (type) {
    case SET_UNITS:
      return {
        ...state,
        units: payload,
      }
    case DELETE_PROJECT:
      return {
        ...state,
        attacks: state.attacks.filter(attack => attack.project_id !== payload),
        obstacles: state.obstacles.filter(
          obstacle => obstacle.project_id !== payload
        ),
        scenarios: state.scenarios.filter(
          scenario => scenario.project_id !== payload
        ),
        projects: state.projects.filter(project => project.id !== payload),
        selectedProjectId: null,
        selectedScenarioId: null,
        selectedObstacle: {},
        selectedAttack: {},
      }
    case DELETE_SCENARIO:
      return {
        ...state,
        attacks: state.attacks.filter(attack => attack.scenario_id !== payload),
        obstacles: state.obstacles.filter(
          obstacle => obstacle.scenario_id !== payload
        ),
        scenarios: state.scenarios.filter(scenario => scenario.id !== payload),
        selectedScenarioId: null,
        selectedObstacle: {},
        selectedAttack: {},
      }
    case TOGGLE_SCENARIO_DIALOG:
      return {
        ...state,
        scenarioDialogOpen: !state.scenarioDialogOpen,
      }
    case SAVE_SCENARIO_DATA:
      return {
        ...state,
        scenarios: [...state.scenarios, { ...payload }],
      }
    case TOGGLE_PROJECT_DIALOG:
      return {
        ...state,
        projectDialogOpen: !state.projectDialogOpen,
      }
    case SAVE_PROJECT_DATA:
      return {
        ...state,
        projects: [...state.projects, { ...payload }],
      }
    case UPDATE_PROJECT_BUILDINGS:
      // console.log('UPDATE_PROJECT_BUILDINGS ', payload)
      return {
        ...state,
        projects: state.projects.map(project =>
          project.id === payload.id
            ? {
                ...project,
                geojson: payload.geojson,
              }
            : project
        ),
      }
    case SET_MAP_CHOICE:
      return {
        ...state,
        mapChoice: payload,
      }
    case LOAD_PROJECTS:
      return {
        ...state,
        projects: payload,
      }
    case SELECT_PROJECT:
      return {
        ...state,
        selectedProjectId: payload,
        selectedScenarioId: null,
        obstacles: state.remoteStorage.obstacles ? [] : state.obstacles,
        attacks: state.remoteStorage.attacks ? [] : state.attacks,
        selectedObstacle: {},
        selectedAttack: {},
      }
    case LOAD_SCENARIOS:
      return {
        ...state,
        scenarios: payload,
      }
    case SELECT_SCENARIO:
      return {
        ...state,
        selectedScenarioId: payload,
        obstacles: state.remoteStorage.obstacles ? [] : state.obstacles,
        attacks: state.remoteStorage.attacks ? [] : state.attacks,
        selectedObstacle: {},
        selectedAttack: {},
      }
    case SAVE_OBSTACLE_DATA:
      if (!state.obstacles.some(o => o.geom_guid === payload.geom_guid)) {
        return {
          ...state,
          obstacles: [...state.obstacles, { ...payload }],
        }
      } else {
        return state
      }
    case SAVE_ATTACK_DATA:
      if (!state.attacks.some(a => a.geom_guid === payload.geom_guid)) {
        const newAttack = {
          ...payload,
          active: true,
        }
        return {
          ...state,
          attacks: [...state.attacks, { ...newAttack }],
          selectedAttack: {},
        }
      } else {
        return state
      }
    case UPDATE_OBSTACLE_DATA:
      return {
        ...state,
        obstacles: state.obstacles.map(obstacle =>
          obstacle.id === payload.id
            ? {
                ...obstacle,
                name: payload.data.name,
                geojson: payload.data.geojson,
              }
            : obstacle
        ),
      }
    case UPDATE_OBSTACLE_BY_GUID:
      return {
        ...state,
        obstacles: state.obstacles.map(obstacle =>
          obstacle.geom_guid === payload.geom_guid
            ? {
                ...obstacle,
                geojson: payload.data.geojson,
              }
            : obstacle
        ),
      }
    case UPDATE_ATTACK_DATA:
      return {
        ...state,
        attacks: state.attacks.map(attack =>
          attack.id === payload.id
            ? {
                ...attack,
                name: payload.data.name,
                geojson: payload.data.geojson,
                start_speed: payload.data.start_speed,
                end_speed: payload.data.end_speed,
                path_length: payload.data.path_length,
                vehicle: payload.data.vehicle,
                recalculated_id: payload.data.recalculated_id,
                original_id: payload.data.original_id,
                active: payload.data.active,
              }
            : attack
        ),
        selectedAttack: {},
      }
    case UPDATE_ATTACK_BY_GUID:
      return {
        ...state,
        attacks: state.attacks.map(attack =>
          attack.geom_guid === payload.geom_guid
            ? {
                ...attack,
                geojson: payload.data.geojson,
              }
            : attack
        ),
        selectedAttack: {},
      }
    case SELECT_OBSTACLE:
      selectedObstacle = payload
        ? state.obstacles.find(o => o.geom_guid === payload)
        : {}
      return {
        ...state,
        selectedObstacle: selectedObstacle,
        selectedAttack: {},
      }
    case SELECT_ATTACK:
      selectedAttack = payload
        ? state.attacks.find(a => a.geom_guid === payload) ?? {}
        : {}
      return {
        ...state,
        selectedAttack: selectedAttack,
        selectedObstacle: {},
      }
    case DELETE_OBSTACLE:
      return {
        ...state,
        obstacles: state.obstacles.filter(o => o.id !== payload),
        selectedAttack: {},
        selectedObstacle: {},
      }
    case DELETE_ATTACK:
      return {
        ...state,
        attacks: state.attacks.filter(a => a.id !== payload),
        selectedAttack: {},
        selectedObstacle: {},
      }
    case DELETE_OBSTACLE_BY_GUID:
      return {
        ...state,
        obstacles: state.obstacles.filter(o => o.geom_guid !== payload),
        selectedAttack: {},
        selectedObstacle: {},
      }
    case DELETE_ATTACK_BY_GUID:
      return {
        ...state,
        attacks: state.attacks.filter(a => a.geom_guid !== payload),
        selectedAttack: {},
        selectedObstacle: {},
      }
    case RESET:
      return {
        ...state,
        selectedProjectId: null,
        selectedScenarioId: null,
        obstacles: state.remoteStorage.obstacles ? [] : state.obstacles,
        attacks: state.remoteStorage.attacks ? [] : state.attacks,
        selectedObstacle: {},
        selectedAttack: {},
      }
    case ACCEPT_T_AND_C:
      return {
        ...state,
        acceptedTandC: true,
      }
    case RESET_T_AND_C:
      return {
        ...state,
        acceptedTandC: false,
      }

    default:
      return state
  }
}

export default rootReducer
